import { Box, Button } from "@mui/material";
import { FC } from "react";
import CachedIcon from "@mui/icons-material/Cached";
import { ViewsStyles } from "../views/ViewsStyles";
import { TFunction } from "i18next";

type RefreshButtonProps = {
  t: TFunction<"global", undefined>;
  refreshData: () => void;
  isDisabled: boolean;
};

const RefreshButton: FC<RefreshButtonProps> = ({
  t,

  refreshData,
  isDisabled,
}) => {
  return (
    <Box>
      <Button
        disabled={isDisabled}
        variant="outlined"
        startIcon={<CachedIcon />}
        onClick={refreshData}
        sx={ViewsStyles.viewsButton}
      >
        {t("MenuOptions.refresh_data")}
      </Button>
    </Box>
  );
};

export default RefreshButton;
